import { Box, Typography, useTheme } from "@mui/material";
import { Circle } from "lucide-react";

export type ITopicsItem = {
    children: JSX.Element | string;
    key?: string | number,
    i?: string | number
}


export const TopicsItem = ({ children, key, i }: ITopicsItem) => {
  const theme = useTheme();
  return (
    <Box
      key={ key }
      sx={ {
        display: "flex",
        justifyContent: "left",
        alignItems: "center"
      } }>
      <Circle style={ { marginLeft: i !== 0 ? "8px" : "0", marginRight: "3px" } }
        fill={ theme.customColors.accentVariantA } size={ "0.4375rem" } />
      <Typography
        sx={ {
          color: theme.customColors.exploreCardText,
          fontSize: "0.75rem",
          marginLeft: "0.3rem"
        } }
        variant="body2"
      >
        { children }
      </Typography>
    </Box>
  );};
